// EDDL dataLayer (Google migration) - outbound_click / file_download.
// Independent of digitalData / Adobe, delegated site-wide from a single capture-phase
// click listener since there is no existing per-link tracking anywhere on the site.
let linkTracking = (function () {
  const DOWNLOAD_EXTENSIONS = [
    'pdf',
    'zip',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'csv',
    'jpg',
    'jpeg',
    'png',
  ];

  function pushDataLayer(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload));
  }

  function getExtension(pathname) {
    const match = pathname.match(/\.([a-z0-9]+)$/i);
    return match ? match[1].toLowerCase() : null;
  }

  function getFileNameWithoutExtension(pathname) {
    const segments = pathname.split('/');
    const fileName = segments[segments.length - 1] || '';
    return fileName.replace(/\.[a-z0-9]+$/i, '');
  }

  // Some downloads (e.g. Contao's `?file=files/.../name.pdf` pattern used on
  // news detail pages) don't carry the file name in the pathname at all - the
  // link itself points at a regular page and the actual file is a query value.
  // Fall back to the first query param whose value looks like a file path.
  function getFileSource(url) {
    if (getExtension(url.pathname)) {
      return url.pathname;
    }

    for (const value of url.searchParams.values()) {
      if (getExtension(value)) {
        return value;
      }
    }

    return url.pathname;
  }

  function isOutboundLink(url) {
    return !!url.host && url.host !== window.location.host;
  }

  function handleClick(event) {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) {
      return;
    }

    const href = anchor.getAttribute('href') || '';
    if (/^\s*(mailto:|tel:|javascript:)/i.test(href)) {
      return;
    }

    let url;
    try {
      url = new URL(anchor.href, window.location.origin);
    } catch {
      return;
    }

    const fileSource = getFileSource(url);
    const extension = getExtension(fileSource);
    const isDownload =
      anchor.hasAttribute('download') ||
      (extension && DOWNLOAD_EXTENSIONS.indexOf(extension) !== -1);

    if (isDownload) {
      pushDataLayer('file_download', {
        link: {
          url: anchor.href,
          file_name: getFileNameWithoutExtension(fileSource),
          file_type: extension || '',
        },
      });
      return;
    }

    if (isOutboundLink(url)) {
      pushDataLayer('outbound_click', {
        link: {
          url: anchor.href,
        },
      });
    }
  }

  function init() {
    document.addEventListener('click', handleClick, true);
  }

  return {
    init: init,
  };
})();
linkTracking.init();
